import { render } from "./UserTable.vue?vue&type=template&id=93d08b72"
import script from "./UserTable.vue?vue&type=script&lang=js"
export * from "./UserTable.vue?vue&type=script&lang=js"

import "./UserTable.vue?vue&type=style&index=0&id=93d08b72&lang=scss"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "93d08b72"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('93d08b72', script)) {
    api.reload('93d08b72', script)
  }
  
  module.hot.accept("./UserTable.vue?vue&type=template&id=93d08b72", () => {
    api.rerender('93d08b72', render)
  })

}

script.__file = "src/components/settings/UserTable.vue"

export default script